import clsx from "clsx"
import { FC, PropsWithChildren } from "react"
import { Button, IButton } from "ui/@button"
import styles from "./index.module.scss"

interface IButtonVip extends IButton {}

export const ButtonVip: FC<PropsWithChildren<IButtonVip>> = ({
  children,
  className,
  classNameContainer,
  ...props
}) => {
  return (
    <Button
      className={clsx(styles.VipPassButton, className)}
      classNameContainer={clsx(
        styles.VipPassButton_container,
        classNameContainer
      )}
      {...props}
    >
      <div className={clsx(styles.VipPassButton_line)} />
      <div className={clsx(styles.VipPassButton_content)}>{children}</div>
    </Button>
  )
}
